<mat-card class="eui-card-container">
    <!-- HEADER -->
    <ng-content *ngIf="cardHeader" select="eui-card-header"></ng-content>
    <!-- MEDIA -->
    <ng-content *ngIf="cardMedia" select="eui-card-media"></ng-content>
    <!-- CONTENT -->
    <ng-content *ngIf="cardContent" select="eui-card-content"></ng-content>
    <!-- FOOTER -->
    <ng-content *ngIf="cardFooter" select="eui-card-footer"></ng-content>
</mat-card>
